export default {
  PPP: 'PPP',
  OZSS: 'OZSS',
  OSOPiP: 'OSOPoP',
  SCHOOL: 'Szkoła',
  PRIVATE_OFFICE: 'Gabinet prywatny',
  COLLEGE: 'Uczelnia',
  OTHER: 'Inne',
};
